import React from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Typography,
} from '@mui/material';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      slot = {},
    },
  },
}) => ({
  slot,
});

const ReassignLeadsDialog = ({ slot }) => (
  <Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      <strong>Calendrier :</strong> {slot.calendrier}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      <strong>Horaire :</strong> {slot.startTime} - {slot.endTime}
    </Typography>
  </Box>
);

export default connect(
  mapStateToProps,
  null
)(ReassignLeadsDialog);
